<template>
    <div class="acc-photo-index">
        <Table :tableThData="tableThData" :tableTrData="tableTrData" :loading="loading" :limit="limit" :offset="offset"
            :total="total" v-on:handleSizeChange="handleSizeChange" v-on:handleCurrentChange="handleCurrentChange">
            <template #type="{ row }">{{ row.type == 1? '发票说明':'常见问题' }}</template>
            <template #mallName="{ row }">{{ row.mallName }}</template>
            <template #invoiceEntrance="{ row }">
                <el-switch  @change="openInvoice(row)" v-model="row.invoiceEntrance" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
            </template>
            <template #operation="{ scope }">
                <auth-button auth="member:point:apply:examine">
                    <el-button type="text" @click="onApply(scope.row)">更新</el-button>
                </auth-button>
            </template>
        </Table>

        <!-- 弹窗 -->
        <Dialog :maskClose="false" :dialogShow="DialogShow" :title="title" @maskClick="() => { DialogShow = false }">
            <template>
                <div class="apply">
                    <el-form :hide-required-asterisk="true" ref="applyForm" :model="applyForm" label-width="100px">
                        <!-- <el-form-item :rules="[{ required: true, message: '请输入标题' },]" label="标题" prop="title">
                            <el-input placeholder="请输入标题" v-model="applyForm.title"  maxlength="100" ></el-input>
                        </el-form-item> -->
                        <el-form-item :rules="[{ required: true, message: '请输入内容' },]" label="内容" prop="content">
                            <el-input placeholder="请输入内容" v-model="applyForm.content" type="textarea" maxlength="1000" :autosize="{ minRows: 20, maxRows: 20}" show-word-limit ></el-input>
                        </el-form-item>
                    </el-form>
                    <div class="button-div">
                        <el-row class="button-div-row">
                            <el-button type="default" class="cancel" @click="() => { DialogShow = false }">取消</el-button>
                            <el-button type="primary" :loading="DialogLoading" class="determine"
                                @click="determine">确定</el-button>
                        </el-row>
                    </div>
                </div>
            </template>
        </Dialog>
    </div>
</template>
  
<script>

import AuthButton from '@/components/AuthButton'
import { api_getInvoiceQuestion , api_postInvoiceQuestion,api_postUpdateInvoiceEntrance } from '@/api/parking'
import tableList from '@/mixins/tableList';
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
import Dialog from "@/components/Dialog/index";
export default {
    name: "invoiceControl",
    mixins: [tableList],
    components: {
        AuthButton,
        Search,
        Table,
        Dialog
    },
    data() {
        return {
            total: 0,
            currentPage: 1,
            offset: 0,
            limit: 10,

            tableThData: [
                { prop: "type", label: "类型", minWidth: "180", },
                { prop: "mallName", label: "商场名称", minWidth: "180", },
                { prop: "invoiceEntrance", label: "电子发票入口", minWidth: "180", },
                { prop: "operation", label: "操作", minWidth: "150", },
            ],
            DialogShow: false,
            DialogLoading: false,
            loading: false,
            applyForm: {
                content: '',
                title:'',
                id: '',
            },
            title:null,
        };
    },
    created() {},
    methods: {
        // 获取发票说明及常见问题
        async getList() {
            this.loading = true
            const params = {
                offset: this.offset,
                limit: this.limit,
                type:1
            }
            try {
                const data = await api_getInvoiceQuestion(params)
                this.tableTrData = data.list
                //  发票入口开关 1：开启 2：关闭
                this.tableTrData.forEach((item,index) =>{
                    item.invoiceEntrance = item.invoiceEntrance == 1 ? true:false
                })
                this.total = data.count
                this.loading = false
            } catch {
                this.loading = false
            }
        },
        // 点击更新按钮
        onApply(row) {
            console.log(row)
            this.DialogShow = true
            this.title = row.type == 1? '发票说明':'常见问题'
            this.applyForm = {
                // title: row.title,
                content: row.content,
                id: row.id,
                type:row.type,
                mallId:row.mallId,
                mallName:row.mallName,
            }
        },
        // 更新确定
        determine() {
            this.$refs.applyForm.validate(async (valid) => {
                if (valid) {
                    this.DialogLoading = true
                    try {
                        let data = {
                            id: this.applyForm.id,
                            mallId: this.applyForm.id,
                            mallName: this.applyForm.id,
                            type: this.applyForm.type,
                            content: this.applyForm.content,
                            // title:this.applyForm.content,
                        }
                        await api_postInvoiceQuestion({ ...data })
                        this.DialogLoading = false
                        this.DialogShow = false
                        this.$baseMessage('操作成功', 'success')
                        this.getList()
                    } catch (error) {
                        this.DialogLoading = false
                    }
                } else {
                    return false
                }
            })
        },
        async openInvoice(e){
            this.loading = true
            console.log(e)
            let params={
                invoiceEntrance:e.invoiceEntrance == true ? 1:2,
                id:e.id
            }
            const data = await api_postUpdateInvoiceEntrance(params)
            this.loading = false
            this.getList()
        },
    },
    computed: {},
};
</script>
<style lang="scss" scoped>
.acc-photo-index {
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;

    .look-phone-btn {
        font-size: 10px;
        color: #1A5CF5;
        margin-left: 5px;
    }

    .fun-btn-box {
        margin-top: 20px;
    }

    .url {
        width: 120px;
        height: 56px;
        object-fit: fill;
        object-fit: contain;
        object-fit: cover;
        object-fit: none;
        object-fit: scale-down;
    }

    .status {
        width: 6px;
        height: 6px;
        display: inline-block;
        border-radius: 50%;
        vertical-align: middle;
    }

    .Passed {
        background: #05c8af;
    }

    .New {
        background: #1A5CF5;
    }

    .Reject {
        background: #F74A4A;
    }

    .button-div {
        overflow: hidden;
        float: right;
        margin-top: 33px;

        button {
            border: 0;
            width: 110px;
            height: 40px;
            border-radius: 2px;
            font-size: 16px;
        }

        .cancel {
            background: #F2F3F5;
            color: #666666;
        }
    }

    .ticketPicUrl {
        width: 150px;
        height: 150px;
        object-fit: fill;
        object-fit: contain;
        object-fit: cover;
        object-fit: none;
        object-fit: scale-down;
        cursor: pointer;
    }

    ::v-deep {
        .content {
            .title {
                margin-bottom: 20px;
            }

            .el-input {
                width: 100%;
            }
        }
    }
}</style>
  